module.exports = __webpack_public_path__ + "media/images/turbochargers/03-6f7ce61ea58dfe823aac2c6e4d3aedd1.png";